// extracted by mini-css-extract-plugin
export var bubble = "_1a-0";
export var container = "_1a-f";
export var contrastBorder = "_1a-g";
export var greyOut = "_1a-2";
export var initialsColor0 = "_1a-3";
export var initialsColor1 = "_1a-4";
export var initialsColor10 = "_1a-d";
export var initialsColor11 = "_1a-e";
export var initialsColor2 = "_1a-5";
export var initialsColor3 = "_1a-6";
export var initialsColor4 = "_1a-7";
export var initialsColor5 = "_1a-8";
export var initialsColor6 = "_1a-9";
export var initialsColor7 = "_1a-a";
export var initialsColor8 = "_1a-b";
export var initialsColor9 = "_1a-c";
export var initialsWrapper = "_1a-1";
export var large = "_1a-l";
export var medium = "_1a-k";
export var mediumSmall = "_1a-j";
export var mediumSmallMedium = "_1a-o";
export var micro = "_1a-h";
export var small = "_1a-i";
export var tiny = "_1a-n";
export var xTiny = "_1a-m";